module.exports = __webpack_public_path__ + "static/media/CP_logo_CMYK_grn.504877ca.jpg";